const icon = require('vue-svgicon');
icon.register({
    'lens-feature-solid': {
        width: 40,
        height: 40,
        viewBox: '0 0 40 40',
        data: `<path pid="0" d="M9 10.4c5.5 0 11-6.4 11-6.4s5.5 6.4 11 6.4c0 9.6 0 16-11 25.6C9 26.4 9 20 9 10.4z" _stroke="#000"/>`,
    },
});
